import {
  Card,
  Checkbox,
  Col,
  DatePicker,
  Row,
  Space,
  TimePicker,
  Title,
} from 'components/common'
import '../discount-style.css'

function onChange(e) {
  console.log(`checked = ${e.target.checked}`)
}

const EffectiveCardChild = (props) => {
  return (
    <>
      {' '}
      <Col span={24}>
        <Space>
          <Col span={12}>
            <Col span={24}>{props.dateTitle}</Col>
            <Col span={24}>
              <DatePicker onChange={onChange} />
            </Col>
          </Col>
          <Col span={12}>
            <Col span={24}>{props.timeTitle}</Col>
            <Col span={24}>
              <TimePicker />
            </Col>
          </Col>
        </Space>
      </Col>
    </>
  )
}

export const EffectiveDateCard = () => {
  return (
    <>
      <Card>
        <Row>
          <Space direction="vertical">
            <Title level={5}>有効日</Title>
            <Row>
              <EffectiveCardChild
                dateTitle={'開始日'}
                timeTitle={'開始時間(EDT)'}
              />
              <Col className="commonPadding" span={24}>
                <Checkbox onChange={onChange}>終了日を設定する</Checkbox>
              </Col>
              <EffectiveCardChild
                dateTitle={'終了日'}
                timeTitle={'終了時間(EDT)'}
              />
            </Row>
          </Space>
        </Row>
      </Card>
    </>
  )
}
